import { GRADIENTS } from "./gradients";

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat("pl-PL", {
    style: "currency",
    currency: "PLN",
  }).format(amount);
};

export const formatDate = (dateString) => {
  if (!dateString) return "Cały okres";
  return new Date(dateString).toLocaleDateString("pl-PL", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const profitColor = (val) => (val >= 0 ? "success.main" : "error.main");

export const profitBg = (val) => (val >= 0 ? GRADIENTS.green : GRADIENTS.red);
